/**
 * Recursively strips marks that aren't in the schema from ProseMirror JSON.
 * Prevents parsing errors when stored content includes marks from a richer schema
 * (e.g. link marks in outline summaries loaded into TiptapField).
 */
export function stripUnknownMarks(json, schema) {
  if (!json) return json;

  const validMarks = new Set(Object.keys(schema.marks));

  const sanitize = (node) => {
    if (!node) return node;

    const result = { ...node };

    if (result.marks) {
      result.marks = result.marks.filter((m) => validMarks.has(m.type));
      if (result.marks.length === 0) {
        delete result.marks;
      }
    }

    if (result.content && Array.isArray(result.content)) {
      result.content = result.content.map(sanitize);
    }

    return result;
  };

  return sanitize(json);
}
